import React from 'react'

const HomepageYoursSessions = () => {
  return (
    <div>HomepageYoursSessions</div>
  )
}

export default HomepageYoursSessions